module.exports = __webpack_public_path__ + "ffb34f1961b63a2c6ee3dcef37afc2b2.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/share-slogan-3.png
// module id = 503
// module chunks = 0